import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, Drawer, IconButton, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
// import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';
import ProfileSection from '../Header/ProfileSection';
import Initial from 'helpers/Initial';
import { useSelector } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import StartIcon from '@mui/icons-material/Start';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const drawer = (
        <>
            {/* <Box sx={{ display: { xs: 'block', md: 'none' } }}>         
                </Box> */}
            <BrowserView>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: "column",
                        // alignItems: 'center',
                        // justifyContent: leftDrawerOpened ? 'initial' : 'center',
                        // gap: 1, 
                        padding: theme.spacing(2), // gives top and bottom spacing
                        mt: 2 // add some top margin to avoid sticking to top
                    }}
                >

                    {/* <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={drawerToggle}
                        edge="start"
                        sx={{
                            color: '#fff',
                            p: 0,
                            // alignItems: 'center',
                            mx: leftDrawerOpened ? "11rem" : "auto",
                            width:"20px" , height:"20px" ,
                        }}
                    >
                       <MenuIcon />
                    </IconButton> */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        {leftDrawerOpened ? <LogoSection /> : <Box />}
                        <IconButton onClick={drawerToggle}>
                            {/* <MenuIcon sx={{ color: '#fff' }} /> */}
                            {leftDrawerOpened ? <KeyboardTabIcon sx={{ color: '#fff', transform: 'rotate(180deg)' }} /> : <StartIcon sx={{ color: '#fff' }} />}
                        </IconButton>
                    </Box>

                    {/* {leftDrawerOpened ? 
                    <Box sx={{ display: 'flex', justifyContent: leftDrawerOpened ? 'initial' : 'center', ml: leftDrawerOpened ? 0 : "0px", }}>
                       <LogoSection/> 
                    </Box> : ""} */}
                </Box>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(70vh - 96px)',
                        paddingLeft: '16px',
                        paddingRight: '16px'
                    }}
                >
                    <MenuList />
                    {/* <MenuCard /> */}
                </PerfectScrollbar>
                <Divider
                    sx={{
                        width: '80%',
                        mx: 'auto',
                        my: 2,
                        borderBottom: '0.1px solid rgba(227, 216, 216, 0.12)', // Directly define the border
                        backgroundColor: 'transparent'     // Prevent background from interfering
                    }}
                />
                <Box sx={{ display: 'flex', justifyContent: leftDrawerOpened ? 'center' : 'center', ml: leftDrawerOpened ? 2 : "0px", mt: matchUpMd ? 4 : 0 }}>
                    <ProfileSection />
                </Box>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                    {/* <MenuCard /> */}
                </Box>
            </MobileView>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;
    return (
        // <Box component="nav" sx={{ flexShrink: { md: 0 }, width: drawerOpen ? 80 : 140, }} aria-label="mailbox folders">
        <Box sx={{ display: 'flex', }}>
            <Drawer
                // className={drawerOpen ? "" : ''}
                container={container}
                // variant={drawerOpen ? 'permanent' : 'persistent'}
                variant="permanent"
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        // width: matchUpMd ? '5.125rem' : 280,
                        width: drawerOpen ? 240 : 83,
                        flexShrink: 0,
                        background: '#3538CD',
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: process.env.REACT_APP_SERVER && process.env.REACT_APP_SERVER == "demo" ? '100px' : '0px'
                        },
                        transition: 'width 0.3s ease',
                        overflow: 'visible',
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
